import { Serializer } from '@lib/store';
import { myBookingInitialState } from './my-booking.reducer';
import { MyBookingState } from './my-booking.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const myBookingStorageDeserializer = (rawObject: any) => {
  return {
    ...myBookingInitialState,
    model: rawObject && rawObject.model ? rawObject.model : null,
  } as MyBookingState;
};

export const myBookingStorageSync: Serializer<MyBookingState> = {
  deserialize: myBookingStorageDeserializer,
};
